import http, { handleServerErrors, apiUrl } from './http'
import auth from './auth'
import alert from './alert'

const id = value => value.id || value

const pagination = (pagination) => {
  return pagination.from === undefined ||
    pagination.to === undefined ||
    pagination.from === null ||
    pagination.to === null ||
    pagination.to - (pagination.from - 1) < pagination.per_page
}

export {
  http,
  handleServerErrors,
  apiUrl,
  id,
  pagination,
  auth,
  alert
}
